export function initMailingSections() {
    const root = document.querySelector('[data-mailing-sections]');
    if (!root) return;

    const panels = Array.from(root.querySelectorAll('[data-mailing-section]'));
    const links = Array.from(root.querySelectorAll('[data-mailing-nav] a'));
    const defaultSection = root.dataset.mailingDefault || 'campanas';

    const selectSection = id => {
        const selected = panels.find(panel => panel.id === id)
            || panels.find(panel => panel.id === defaultSection)
            || panels[0];
        if (!selected) return;

        panels.forEach(panel => { panel.hidden = panel !== selected; });
        links.forEach(link => {
            const active = link.hash === `#${selected.id}`;
            link.classList.toggle('btn--primary', active);
            if (active) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
        });
        return selected.id;
    };

    links.forEach(link => {
        link.addEventListener('click', event => {
            if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            const id = selectSection(link.hash.slice(1));
            if (id && location.hash !== `#${id}`) history.pushState(null, '', `#${id}`);
        });
    });

    const selectFromLocation = () => selectSection(location.hash.slice(1));
    window.addEventListener('hashchange', selectFromLocation);
    window.addEventListener('popstate', selectFromLocation);

    // A submitted form opens its result, even if the previous hash names another section.
    if (root.dataset.mailingResponse === 'true') {
        const id = selectSection(defaultSection);
        if (id) history.replaceState(null, '', `#${id}`);
    } else {
        selectFromLocation();
    }
}
